import{create as t}from"mutative";const e=(e,s)=>(n,a,o)=>(o.setState=(e,a,...o)=>{const c="function"==typeof e?t(e,s?Object.assign(Object.assign({},s),{enablePatches:!1}):s):e;return n(c,a,...o)},e(o.setState,a,o));export{e as mutative};
//# sourceMappingURL=index.esm.js.map
